// extracted by mini-css-extract-plugin
export default {"imageIcon":"Image1_imageIcon__E1UpY","image21":"Image1_image21__DN7Ti"};